import { Component, input } from '@angular/core';

@Component({
  selector: 'app-icon',
  templateUrl: './icon.component.html',
  styleUrl: './icon.component.scss'
})
export class IconComponent {
  public alt = input<string>('');
  public ariaHidden = input<boolean>(true);
  public className = input<string>('');
  public height = input<number>(24);
  public loading = input<string>('lazy');
  public src = input.required<string>();
  public width = input<number>(24);
}
